/**
 * Created by XUQIANG on 2016/4/14.
 */
import React from 'react';
import { Carousel } from 'antd';

const banner1 = require('../../assets/banner1.png');
// const banner2 = require('../../assets/banner2.jpg');
// const banner3 = require('../../assets/banner3.jpg');
// const banner4 = require('../../assets/banner4.jpg');
// const banner5 = require('../../assets/banner5.jpg');
// const banner6 = require('../../assets/banner6.jpg');
// const banner7 = require('../../assets/banner7.jpg');
// const banner8 = require('../../assets/banner8.jpg');

export default () => (
  <Carousel
    autoplay="false"
    dots="false"
    fade="ture"
    draggable="false"
    effect="fade"
  >
    <div className="carousel">
      <img src={banner1} />
    </div>
    {/*<div className="carousel">*/}
    {/*  <img src={banner2} />*/}
    {/*</div>*/}
    {/*<div className="carousel">*/}
    {/*  <img src={banner3} />*/}
    {/*</div>*/}
    {/*<div className="carousel">*/}
    {/*  <img src={banner4} />*/}
    {/*</div>*/}
    {/*<div className="carousel">*/}
    {/*  <img src={banner5} />*/}
    {/*</div>*/}
    {/*<div className="carousel">*/}
    {/*  <img src={banner6} />*/}
    {/*</div>*/}
    {/*<div className="carousel">*/}
    {/*  <img src={banner7} />*/}
    {/*</div>*/}
    {/*<div className="carousel">*/}
    {/*  <img src={banner8} />*/}
    {/*</div>*/}
  </Carousel>
);



// WEBPACK FOOTER //
// ./src/components/login/ReservationCarouser.js